// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"235":"75438608","913":"dd7d8902","1367":"c1a1f6ce","4044":"08f3d62b"}[chunkId] + ".chunk.css";
};